import { Routes } from "@angular/router";
import { FreightListingComponent } from "./freight-listing/freight-listing.component";
export const freightQuoteRoutes: Routes = [
  {
    path: 'listing',
    component: FreightListingComponent
  }
];
